<template>
  <q-dialog class="dialog">
    <q-card>
      <form :action="$route('search.start')" method="GET">
        <q-card-section class="row" :class="{'q-px-lg': $isDesktop}">
          <div class="col-9 col-sm-8 heading-3 q-mr-sm">Bekijk eerder zoekresultaat</div>
          <q-space />
          <icon-button class="col-2"  icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup />
        </q-card-section>
        <q-card-section class="dialog__form" :class="{'q-px-lg': $isDesktop}">
          <p>
            Vul hier de code van uw project in, waarvoor u eerder richtlijnen heeft opgevraagd. De code vindt u in de
            mail die u toegezonden heeft gekregen bij de eerste invoer van uw project.
          </p>
          <common-input
              v-model="form.hash"
              label="code"
              name="hash"
              autofocus
            />
        </q-card-section>
        <q-separator />
        <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
          <accent-button label="Bekijk project" type="submit"/>
        </q-card-actions>
      </form>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  data(){
    return {
      form: {
        hash: ''
      }
    }
  }
}
</script>